import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ColoredTelescopeIcon: React.FC<SvgIconProps> = ({
  variant,
  ...props
}) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <path
            d="M6.15799 8.63306L7.27199 13.0891"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#9625D8"
          />
          <path
            d="M10.065 12.493L3.885 13.811C3.64512 13.8631 3.39438 13.8186 3.18703 13.6873C2.97968 13.5559 2.83238 13.3482 2.777 13.109L2.24 10.959C2.17686 10.7 2.21271 10.4267 2.34053 10.1927C2.46835 9.95873 2.67892 9.78089 2.931 9.69403L16.435 5.25403"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
            fill="transparent"
          />
          <path
            d="M13.56 11.747L17.892 10.823"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M16 21L12.895 14.79"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M16.485 5.93999C16.3565 5.42548 16.4375 4.88097 16.7104 4.42622C16.9832 3.97146 17.4255 3.64369 17.94 3.51499L19.03 3.24299C19.2871 3.17885 19.5592 3.21939 19.7864 3.3557C20.0137 3.49202 20.1775 3.71296 20.242 3.96999L21.757 10.03C21.8214 10.2873 21.7811 10.5596 21.6447 10.7871C21.5084 11.0145 21.2873 11.1785 21.03 11.243L19.94 11.515C19.4255 11.6435 18.881 11.5625 18.4262 11.2896C17.9715 11.0168 17.6437 10.5745 17.515 10.06L16.485 5.93999Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#9625D8"
          />
          <path
            d="M8 21L11.105 14.79"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
        </>
      ) : (
        <>
          <path
            d="M6.15799 8.63306L7.27199 13.0891"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#9625D8"
          />
          <path
            d="M17 11L3.885 13.811C3.64512 13.8631 3.39438 13.8186 3.18703 13.6873C2.97968 13.5559 2.83238 13.3482 2.777 13.109L2.24 10.959C2.17686 10.7 2.21271 10.4267 2.34053 10.1927C2.46835 9.95873 2.67892 9.78089 2.931 9.69403L16.435 5.25403"
            fill="#9625D8"
            fillOpacity="0.3"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M13.56 11.747L17.892 10.823"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M16 21L12.895 14.79"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M16.485 5.93999C16.3565 5.42548 16.4375 4.88097 16.7104 4.42622C16.9832 3.97146 17.4255 3.64369 17.94 3.51499L19.03 3.24299C19.2871 3.17885 19.5592 3.21939 19.7864 3.3557C20.0137 3.49202 20.1775 3.71296 20.242 3.96999L21.757 10.03C21.8214 10.2873 21.7811 10.5596 21.6447 10.7871C21.5084 11.0145 21.2873 11.1785 21.03 11.243L19.94 11.515C19.4255 11.6435 18.881 11.5625 18.4262 11.2896C17.9715 11.0168 17.6437 10.5745 17.515 10.06L16.485 5.93999Z"
            fill="#9625D8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M8 21L11.105 14.79"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
          <path
            d="M12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15Z"
            fill="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#262626"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default ColoredTelescopeIcon;
